var Backbone = require('backbone');

var Email = Backbone.Model.extend({
    defaults: {
        model: {},
        template: 'email001',
        to: ''
    },
    urlRoot: EY.Consultation.Lookups.API.Notification + 'send'
});

module.exports.send = function (options) {
    var model = options.model;
    var template = options.template;
    var to = options.to;

    if (model && template && to) {
        new Email({
            model: model.attributes,
            template: template,
            to: to
        }).save();
    }
};


// WEBPACK FOOTER //
// ./js/Modules/Service/Email.js